module.exports = __webpack_public_path__ + "static/media/fabien_200x200.38d9e030.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/fabien_200x200.png
// module id = 230
// module chunks = 0